var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63086 5.5625L0.177734 2.10938C0.0592448 1.99089 0 1.84701 0 1.67773C0 1.50846 0.0592448 1.36458 0.177734 1.24609L0.761719 0.6875C0.880208 0.56901 1.02409 0.509766 1.19336 0.509766C1.36263 0.509766 1.50651 0.56901 1.625 0.6875L4.0625 3.125L6.5 0.6875C6.61849 0.56901 6.76237 0.509766 6.93164 0.509766C7.10091 0.509766 7.24479 0.56901 7.36328 0.6875L7.94727 1.24609C8.06576 1.36458 8.125 1.50846 8.125 1.67773C8.125 1.84701 8.06576 1.99089 7.94727 2.10938L4.49414 5.5625C4.37565 5.68099 4.23177 5.74023 4.0625 5.74023C3.89323 5.74023 3.74935 5.68099 3.63086 5.5625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBlack);
export default __webpack_public_path__ + "static/media/arrow_down--black.99faef87452f5c592f84bf0f96f7fd9d.svg";
export { ForwardRef as ReactComponent };